<template>
  <div id="a7" class="we-client">
    <div class="we-client-swiper-div">
      <div @mouseover="khstop(1)" @mouseleave="khstart(1)">
        <swiper
          class="we-client-swiper"
          ref="khlb1"
          :options="swiperOptionsWeClient"
        >
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-01.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-02.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-03.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-04.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-05.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-06.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-07.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-08.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-09.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-10.png'" />
          </swiper-slide>
        </swiper>
      </div>
      <div @mouseover="khstop(2)" @mouseleave="khstart(2)">
        <swiper
          class="we-client-swiper"
          ref="khlb2"
          :options="swiperOptionsWeClient"
          style="width: 106%; margin-left: -6%"
        >
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-11.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-12.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-13.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-14.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-15.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-16.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-17.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-18.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-19.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-20.png'" />
          </swiper-slide>
        </swiper>
      </div>
      <div @mouseover="khstop(3)" @mouseleave="khstart(3)">
        <swiper
          class="we-client-swiper"
          ref="khlb3"
          :options="swiperOptionsWeClient"
        >
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-21.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-22.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-23.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-24.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-25.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-26.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-27.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-28.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-29.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-30.png'" />
          </swiper-slide>
        </swiper>
      </div>
      <div @mouseover="khstop(4)" @mouseleave="khstart(4)">
        <swiper
          class="we-client-swiper"
          ref="khlb4"
          :options="swiperOptionsWeClient"
          style="width: 106%; margin-left: -6%"
        >
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-31.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-32.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-33.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-34.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-35.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-36.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-37.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-38.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-39.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-40.png'" />
          </swiper-slide>
        </swiper>
      </div>
      <div @mouseover="khstop(5)" @mouseleave="khstart(5)">
        <swiper
          class="we-client-swiper"
          ref="khlb5"
          :options="swiperOptionsWeClient"
        >
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-41.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-42.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-43.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-44.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-45.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-46.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-47.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-48.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-49.png'" />
          </swiper-slide>
          <swiper-slide class="we-client-swiper-slide">
            <img :src="fileServerUrl + 'assets/sponsor/logox50-50.png'" />
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="client-hover">
      <div class="client-hover-font">
        <span style="color: #fff; opacity: 1">100+</span>
        <span style="color: white; opacity: 1; position: relative">
          {{ $t("institution") }}<br />
          {{ $t("trust_in_us") }}
        </span>
      </div>
    </div>
    <!--        <div class="client-hover2">-->

    <!--        </div>-->
    <div class="xlzz-bottom-xh"></div>
    <div class="xlzz-bottom-xh2"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileServerUrl: fileServerUrl,
      aboutShow: false,
      aboutPShow: false,
      activeIndex: 1,
      hxywTpHoverIndex: 0, //核心业务图片悬浮
      pphdTpHoverIndex: 0, //品牌活动图片悬浮
      xmhgTpActive: 1, //项目回顾点击的第几个项目
      // swiper配置项:
      swiperOptions: {
        //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        effect: "slide",
        // 无限循环
        loop: true,
        // 自动滚动
        // autoplay: true, //默认的效果
        // 个性化配置
        autoplay: {
          delay: 2000, //间隔时长, 单位毫秒
          disableOnInteraction: false, //用户操作swiper后是否禁用自动滚动
        },
        // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //响应点击事件
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 我们的客户swiper配置项:
      swiperOptionsWeClient: {
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true,
        speed: 3000,
        //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        effect: "slide",
        // 无限循环
        loop: true,
        // 自动滚动
        // autoplay: true, //默认的效果
        // 个性化配置
        autoplay: {
          delay: 0, //间隔时长, 单位毫秒
          disableOnInteraction: false, //用户操作swiper后是否禁用自动滚动
          stopOnLastSlide: false,
        },
        // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //响应点击事件
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    counter1(item) {
      const returnEle = document.querySelector(item);
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
      document.querySelector(item).scrollIntoView(true);
    },
    slideChange() {
      this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex;
    },
    mouseOver(e) {
      // console.log(e)
    },
    mouseLeave(e) {
      // console.log(e)
    },
    khstop(index) {
      // this.$refs[`khlb`+index].$swiper.autoplay.stop();
    },
    khstart(index) {
      // this.$refs[`khlb`+index].$swiper.autoplay.start();
    },
    showHddb() {
      return document.documentElement.scrollTop >= 700;
    },
    handleScroll() {
      this.currentScroll = window.pageYOffset; //表示当前滚动的位置

      if (this.currentScroll >= this.$refs.aboutUsref.offsetTop - 750) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutShow = true;
      } else {
        this.aboutShow = false;
      }

      if (this.currentScroll >= this.$refs.aboutProgram.offsetTop - 750) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutPShow = true;
      } else {
        this.aboutPShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.xlzz-bottom-xh {
  width: 20%;
  height: 85%;
  top: 2%;
  position: absolute;
  //border: .1px solid red;
  right: 0;
  z-index: 2;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}
.xlzz-bottom-xh2 {
  top: 2%;
  width: 20%;
  height: 85%;
  position: absolute;
  z-index: 2;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}
.we-client {
  color: #333333;
  //margin-bottom: 40px;

  //background-color: rgb(60, 46, 138,0.9);
  position: relative;
}
.we-client-title {
  padding-top: 12px;
  text-align: center;
  font-weight: bold;
  font-size: 15px;
}

.we-client-swiper-div {
  margin-top: 25px;
  margin-bottom: 23px;
  //width: 100%;
  width: 100%;
  height: 5%;
}

.client-hover {
  width: 27%;
  height: 21%;
  position: absolute;
  left: 38%;
  top: 35%;
  border-radius: 30px;
  background-color: #f13535ff;
  opacity: 0.8;
  z-index: 22;
  display: flex;
  align-items: center;
  justify-content: center;
}
.client-hover2 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(216, 219, 255, 0.5);
  z-index: 21;
}

.client-hover-font {
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 1%;
}

.we-client-swiper {
  margin-top: 20px;
  margin-left: 15px;
  margin-right: 5px;
  width: 100%;
}
.we-client-swiper-slide {
  width: 10%;
  height: 5%;
  margin-bottom: 5px;
  //border:1px solid red;
}
.we-client-swiper-slide img {
  width: 75%;
  height: 80%;
  //border:1px solid red;
  margin-left: 14px;
  //border:1px solid red;
}
.swiper-wrapper {
  -moz-transition-timing-function: linear !important;
  -webkit-transition-timing-function: linear !important;
  -ms-transition-timing-function: linear !important;
  -o-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}
</style>
